import { IFetchHookOptions, useFetch } from 'ts/common/hooks';
import useEvent from './useEvent';

const useGalleryApiFetch = <TResponse>(path: string, fetchOptions?: IFetchHookOptions) => {
    const { id, publicId } = useEvent();
    const eventId = publicId ? publicId : id;
    return useFetch<TResponse>(
        new URL(`/gallery/${eventId}/${path}`, window.location.origin).toString(),
        fetchOptions
    );
};

export default useGalleryApiFetch;
